module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_1-a3e75c9eede8e97e1401162afb9cec6a.png";